'use strict';

// dom
const {
	h1, a, div, header, p, i, img,
	section, button, span, ul, li
} = require('iblokz-snabbdom-helpers');
// components
const grid = require('../../../comp/grid').default ?? require('../../../comp/grid');
const {fieldLabel} = require('../../../comp/form/label');

const {obj} = require('iblokz-data');
const _rl = require('../../../../util/resolve-localized');
const {resolveLocalized, DEFAULT_LOCALE} = _rl.default || _rl;

const orderWeight = [
	'_id', 'name', 'title',
	'function', 'type',
	'values', 'default',
	'author', 'start', 'end'
];

const skipFields = ['description', 'info'];

const schemaToFields = (schema, i18n) => ['_id'].concat(Object.keys(schema || {}))
	.sort((a, b) => orderWeight[b] - orderWeight[a])
	.map(field => obj.switch(field, {
		default: () => ({name: field, title: fieldLabel(i18n, field)}),
		_id: () => ({name: '_id', title: fieldLabel(i18n, '_id')})
	})());

module.exports = ({state, actions, i18n}) => {
	const collection = state.router.path[1];
	const view = state.rest.views && state.rest.views[collection];
	const colMeta = state.rest.collections
		&& state.rest.collections[collection];
	const schema = colMeta && colMeta.schema;
	const i18nFields = (colMeta && colMeta.i18n) || [];
	const lang = state.lang || DEFAULT_LOCALE;

	const withSchema = field => {
		const name = field.name || field;
		const fieldSchema = schema && schema[name];
		const type = fieldSchema && (
			typeof fieldSchema === 'string'
				? fieldSchema
				: fieldSchema.type
		);
		const titled = typeof field === 'string'
			? {name: field, title: fieldLabel(i18n, field)}
			: Object.assign({}, field, {
				title: fieldLabel(i18n, name)
			});
		return Object.assign({}, titled, {
			schema: titled.schema || (type ? {type} : {}),
			i18n: i18nFields.indexOf(name) > -1
		});
	};

	const list = (state[collection].list || []).map(doc => {
		const out = Object.assign({}, doc);
		i18nFields.forEach(key => {
			if (out[key] !== undefined) {
				out[key] = resolveLocalized(out[key], lang);
			}
		});
		return out;
	});

	return [
		button('.btn', {on: {click: () => actions.router.go(`admin.${collection}.new`)}}, [
			i('.fa.fa-file-o'),
			' ',
			i18n.common.actions.create
		]),
		grid({
			i18n,
			fields: (view
				? view.list.columns
				: schemaToFields(schema, i18n)
			).map(withSchema),
			list,
			actions: [
				{
					sel: '.grid-action-button',
					title: img(`[src='/assets/icons/edit.svg']`),
					cb: ({doc, ev}) => actions.router.go(`admin.${collection}.${doc._id}`)
				},
				{
					sel: '.grid-action-button',
					title: img(`[src='/assets/icons/delete.svg']`),
					cb: ({doc, ev}) => actions[collection].delete(doc._id, state.auth.token)
				}
			]
		})
	];
};
